// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import UpdateRoundSvg from '@rsuite/icon-font/lib/status/UpdateRound';
var UpdateRound = createSvgIcon({
  as: UpdateRoundSvg,
  ariaLabel: 'update round',
  category: 'status',
  displayName: 'UpdateRound'
});
export default UpdateRound;